import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    $('.nyt-critics-pick').each((i, el) => {
        const $image = $(el);
        const $container = $image.parents('.content-section');
        $container.find('.content-background-image__images').append($image.clone());
        $container.find('.bg-video-controls').prepend($image.clone());
    });
});
